import React from 'react';
import { Route } from "react-router-dom";
import CallTypesView from './call_types.view';


const CallTypesRouter = ({ match }) => (
  <div>
    <Route
      path={match.path}
      component={CallTypesView}
    />
  </div>
);

export default CallTypesRouter;
